import { COMMON_SET_CHANNEL_RELATION } from './constants';

export function setChannelRelation(data) {
  return {
    type: COMMON_SET_CHANNEL_RELATION,
    data,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_SET_CHANNEL_RELATION:
      return {
        ...state,
        channelRelation: action.data,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/setChannelRelation.js